import { isDev } from "#configuration/config";
import { useStores } from "#stores";
import { ALLOWED_DOMAINS } from "./constants";

export const useModularization = () => {
	const { organizationStore, authStore } = useStores();
	const hasModularizationOrgFeature = organizationStore.organization?.features.some(
		feature => feature.id === "modularization",
	);

	const username = authStore.currentEmployee?.username;

	const isAllowedUser =
		username && ALLOWED_DOMAINS.some(domain => username.includes(domain));

	// TODO: remover solução temporária para uso em testes no ambiente dev
	const forceMenuV1 = localStorage.getItem("menu-v1");

	const showMenuV2 = isDev
		? isDev && !forceMenuV1
		: Boolean(hasModularizationOrgFeature || isAllowedUser);

	return {
		showMenuV2,
	};
};
